import {
  BooleanField,
  BooleanInput,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ListActions,
  NumberField,
  NumberInput,
  SelectField,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { Currency, DormitoryRoomTypeStatuses, MOBILE_BREAKPOINT } from "utils/constants";
import { DormitoryRoomTypeStatusChoices } from "utils/choices";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { dormitoryRequests } from "api/dormitoryApi";
import StatusToggleDialog from "../Partials/StatusToggleDialog";
import DatagridActions from "../Partials/DatagridActions";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";

const listFilters = [
  <TextInput
    source="description"
    label="Описание"
    alwaysOn
  />,
  <DormitoryAutocompleteInput
    source="status"
    label="Статус"
    choices={DormitoryRoomTypeStatusChoices}
    alwaysOn
    emptyText={"Всички"}
  />,
  <NumberInput
    source="quadrature"
    label="Квадратура"
  />,
  <BooleanInput
    source="terrace"
    label="Тераса"
  />,
  <NumberInput
    source="capacity"
    label="Места"
  />,
  <BooleanInput
    source="suitableForFamily"
    label="Подходящ за семейство с деца"
  />,
  <BooleanInput
    source="suitableForDisabled"
    label="Подходящ за хора с увреждания"
  />,
];

const currencyOptions = { style: "currency", currency: Currency.EUR, minimumFractionDigits: 2 };

const roomTypeStatusToggle = record => (
  <SecuredComponent permission={permissions.canManageDormitoryRoomTypes}>
    <StatusToggleDialog
      isActive={record?.status === DormitoryRoomTypeStatuses.Active}
      activateUrl={dormitoryRequests.activateRoomType(record?.id)}
      deactivateUrl={dormitoryRequests.deactivateRoomType(record?.id)}
      confirmMessage="Сигурни ли сте, че искате да смените статуса на типа стая?"
      successMessage="Успешно сменихте статуса на типа стая"
    />
  </SecuredComponent>
);

const roomTypeActions = record => (
  <>
    <SecuredComponent permission={permissions.canManageDormitoryRoomTypes}>
      <EditButton label="Редактирай" />
    </SecuredComponent>
    <SecuredComponent permission={permissions.canPreviewDormitoryRoomTypes}>
      <ShowButton label="Преглед" />
    </SecuredComponent>
    {roomTypeStatusToggle(record)}
  </>
);

const ListRoomTypes = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Типове стаи"
      exporter={false}
      filters={listFilters}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageDormitoryRoomTypes)} />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Описание", value: record?.descriptionBg }]} />
          )}
          secondaryText={() => (
            <div>
              <MobileListRow
                fields={[
                  { label: "Квадратура", value: <NumberField source="quadrature" /> },
                  { label: "Места", value: <NumberField source="capacity" /> },
                ]}
              />
              <MobileListRow
                fields={[
                  { label: "Наем за стаята", value: <NumberField source="roomRental" options={currencyOptions} /> },
                  { label: "Наем на човек", value: <NumberField source="costPerPerson" options={currencyOptions} /> },
                ]}
              />
              <MobileListRow
                fields={[
                  { label: "Статус", value: <SelectField source="status" choices={DormitoryRoomTypeStatusChoices} /> },
                ]}
              />
            </div>
          )}
          tertiaryText={record => roomTypeActions(record, true)}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="descriptionBg"
            label="Описание"
            sortable={false}
          />
          <NumberField
            source="quadrature"
            label="Квадратура"
            textAlign="right"
            sortable={false}
          />
          <NumberField
            source="capacity"
            label="Места"
            textAlign="right"
            sortable={false}
          />
          <BooleanField
            source="terrace"
            label="Тераса"
            textAlign="center"
            sortable={false}
          />
          <NumberField
            source="roomRental"
            label="Наем за стаята"
            options={currencyOptions}
            textAlign="right"
            sortable={false}
          />
          <NumberField
            source="costPerPerson"
            label="Наем на човек"
            options={currencyOptions}
            textAlign="right"
            sortable={false}
          />
          <SelectField
            source="status"
            label="Статус"
            choices={DormitoryRoomTypeStatusChoices}
            sortable={false}
          />
          <FunctionField
            source="actions"
            label={false}
            sortable={false}
            render={record => <DatagridActions>{roomTypeActions(record)}</DatagridActions>}
          />
        </Datagrid>
      )}
    </List>
  );
};
export default ListRoomTypes;
